import { render, staticRenderFns } from "./japan1122.vue?vue&type=template&id=7b1ca34e&scoped=true"
import script from "./japan1122.vue?vue&type=script&lang=js"
export * from "./japan1122.vue?vue&type=script&lang=js"
import style0 from "./japan1122.vue?vue&type=style&index=0&id=7b1ca34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ca34e",
  null
  
)

export default component.exports